import { render } from "./PaymentListLayout.vue?vue&type=template&id=31bccee4&ts=true"
import script from "./PaymentListLayout.vue?vue&type=script&lang=ts"
export * from "./PaymentListLayout.vue?vue&type=script&lang=ts"

import "./PaymentListLayout.vue?vue&type=style&index=0&id=31bccee4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__